import {
  CalendarEventWriteResult,
  UpdateCalendarEventInput,
} from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type UpdateExternalCalendarEventOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: UpdateCalendarEventInput;
};

export const updateExternalCalendarEvent = async <TFunctions>(
  options: UpdateExternalCalendarEventOptions<TFunctions>,
): Promise<CalendarEventWriteResult> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<
    UpdateCalendarEventInput,
    CalendarEventWriteResult
  >(functions, 'externalCalendars-updateEvent');

  const { data } = await callable(payload);

  return data;
};
